// Parser estrito para URLs do YouTube.
// Princípios:
// - Whitelist de hosts (defende contra subdomain takeover e similares)
// - Apenas HTTPS (YouTube redireciona HTTP de qualquer forma)
// - IDs de vídeo têm exatamente 11 caracteres (spec do YouTube)
// - Lookahead garante que o ID termina (não é prefixo de algo maior)

const SAFE_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'];

const ID_REGEX = /^[A-Za-z0-9_-]{11}$/;
const ID_IN_URL_REGEX = /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})(?:[^A-Za-z0-9_-]|$)/;

export const isValidYoutubeId = (s) => typeof s === 'string' && ID_REGEX.test(s);

export const extractYoutubeId = (url) => {
    if (!url || typeof url !== 'string') return null;
    let parsed;
    try {
        parsed = new URL(url.trim());
    } catch {
        return null;
    }
    if (!SAFE_HOSTS.includes(parsed.hostname)) return null;
    if (parsed.protocol !== 'https:') return null;

    const match = url.match(ID_IN_URL_REGEX);
    return match ? match[1] : null;
};

export const getYoutubeThumbnail = (urlOrId) => {
    if (!urlOrId) return null;
    const id = isValidYoutubeId(urlOrId) ? urlOrId : extractYoutubeId(urlOrId);
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

export const buildOembedUrl = (id) =>
    `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${id}&format=json`;
